import { WindowsAgentClient } from "./WindowsAgentClient"

const HEARTBEAT_INTERVAL_MS = 5000
const AGENT_SOUND_READY_URL = 'http://127.0.0.1:17845/soundReady'

/**
 * Tells the optional local Windows agent whether this webapp instance is currently ready
 * to ring for new orders itself (open, logged in, WebSocket connected) - see
 * WindowsAgentClient.reportSoundReady. The agent only falls back to its own alarm when it
 * hasn't heard from us recently, so this only matters while ready:true would otherwise be
 * stale - reporting stops (rather than switching to a slow "not ready" cadence) as soon as
 * we're not ready, via setReady(false) below.
 *
 * Wired into Counter.js's messaging connect/onPause/onResume/unsubscribe lifecycle, not
 * into App.js's login/logout handlers directly - those lifecycle points already track
 * exactly the "ready to ring" state this bridge needs to mirror.
 */
export class WindowsAgentSoundReadyBridge {

	_ready = false
	_interval

	start = () => {
		this.setReady(true)
		clearInterval(this._interval)
		this._interval = setInterval(this._push, HEARTBEAT_INTERVAL_MS)
		window.addEventListener('pagehide', this._onPageHide)
	}

	stop = () => {
		clearInterval(this._interval)
		window.removeEventListener('pagehide', this._onPageHide)
		this.setReady(false)
	}

	setReady = ready => {
		this._ready = ready
		this._push()
	}

	_push = () => WindowsAgentClient.reportSoundReady(this._ready)

	_onPageHide = () => {
		if (navigator.sendBeacon) {
			navigator.sendBeacon(AGENT_SOUND_READY_URL, JSON.stringify({ ready: false }))
		}
	}

}
